module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gc-Hb-Ia.6c2e7d53.png";